module.exports = __webpack_public_path__ + "img/img_sub_prod_brityassistant01.72fa6790.svg";